

export const CONTENT_DETAILS_REQUEST = "CONTENT_DETAILS_REQUEST";
export const CONTENT_DETAILS_SUCCESS = "CONTENT_DETAILS_SUCCESS";
export const CONTENT_DETAILS_FAIL = "CONTENT_DETAILS_FAIL";

export const ALL_CONTENT_REQUEST = "ALL_CONTENT_REQUEST";
export const ALL_CONTENT_SUCCESS = "ALL_CONTENT_SUCCESS";
export const ALL_CONTENT_FAIL = "ALL_CONTENT_FAIL";

export const ADMIN_CONTENT_REQUEST = "ADMIN_CONTENT_REQUEST";
export const ADMIN_CONTENT_SUCCESS = "ADMIN_CONTENT_SUCCESS";
export const ADMIN_CONTENT_FAIL = "ADMIN_CONTENT_FAIL";

export const UPDATE_CONTENT_REQUEST = "UPDATE_CONTENT_REQUEST";
export const UPDATE_CONTENT_SUCCESS = "UPDATE_CONTENT_SUCCESS";
export const UPDATE_CONTENT_RESET = "UPDATE_CONTENT_RESET";
export const UPDATE_CONTENT_FAIL = "UPDATE_CONTENT_FAIL";

export const DELETE_CONTENT_REQUEST = "DELETE_CONTENT_REQUEST";
export const DELETE_CONTENT_SUCCESS = "DELETE_CONTENT_SUCCESS";
export const DELETE_CONTENT_RESET = "DELETE_CONTENT_RESET";
export const DELETE_CONTENT_FAIL = "DELETE_CONTENT_FAIL";

export const NEW_CONTENT_REQUEST = "NEW_CONTENT_REQUEST";
export const NEW_CONTENT_SUCCESS = "NEW_CONTENT_SUCCESS";
export const NEW_CONTENT_RESET = "NEW_CONTENT_RESET";
export const NEW_CONTENT_FAIL = "NEW_CONTENT_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
